'use client';
import { useEffect } from 'react';
import publicEnv from '../publicEnv';

// Type assertion for publicEnv since it's a CommonJS module
const typedPublicEnv = publicEnv as {
  API_BASE: string;
  APP_BASE: string;
  DRYNOTES_ENV: string;
  DRYNOTES_HOST: string;
  DRYNOTES_HOST_NAME: string;
  DRYNOTES_PORT: number;
  DRYNOTES_LOGIN: string;
  GA_TRACKING_ID: string;
  HOT_RELOADING: boolean;
  LOG_LEVEL: string;
  NODE_ENV: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_MEASUREMENT_ID: string;
};

const {
  API_BASE
} = typedPublicEnv;

declare global {
  interface Window {
    __ENV__: any;
    API_BASE: any;
    DRY: any;
    VERSION: string;
  }
};

export function GenerateGlobalVariables(): null {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.__ENV__ = JSON.stringify(publicEnv);
      window.VERSION = process.env.VERSION || '1.22.3';
      window.DRY = window.DRY || {};
      window.API_BASE = API_BASE;
    }
  }, []);
  return null;
}
